import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";
import { IAreasTransfers } from "commonFnBcode/types/dmc.types";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";

const queryGenerator = (query) =>
  `${Object.keys(query)
    .map((k) => `${k}=${query[k]}`)
    .join("&")}`;

export const areasTransferApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    //=============================== get all areas =====================================
    fetchAreasTransfer: build.query<IJSONResponse<IAreasTransfers[]>, any>({
      query: (query) => `areas/getTransfers?${queryGenerator(query)}`,
      providesTags: [ActivityTags.getAreasTransfers],
    }),

    //=============================== delete area =====================================
    deleteAreaTransfer: build.mutation<IJSONResponse, number>({
      query: (id) => ({
        url: `areas/deleteTransfers/${id}`,
        method: "POST",
      }),
      invalidatesTags: [ActivityTags.getAreasTransfers],
    }),

    //=============================== add area =====================================
    addAreaTransfer: build.mutation<IJSONResponse, any>({
      query: (body) => ({
        url: "areas/createTransfers",
        method: "POST",
        body,
      }),
      invalidatesTags: [ActivityTags.getAreasTransfers],
    }),

    //=============================== Get Filtered areas =====================================
    fetchFilteredAreas: build.query<IJSONResponse, any>({
      query: (query) => `areas/getFilteredAreas?${queryGenerator(query)}`,
    }),

    //=============================== Get Filtered Area Transfers =====================================
    getFilteredAreaTransfers: build.query<IJSONResponse, any>({
      query: (query) =>
        `areas/getFilteredAreasTransfers?${queryGenerator(query)}`,
    }),

    //=============================== Get Filtered Area Transfers Type=====================================
    getFilteredTransfersTypes: build.query<IJSONResponse, any>({
      query: (query) =>
        `areas/getFilteredAreasTransfersType?${queryGenerator(query)}`,
    }),
  }),
  overrideExisting: false,
});
